module.exports = __webpack_public_path__ + "static/interview_map_01_ja-d8db4043bdd4cb5b7301a33620615fcd.svg";